import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  border-radius: 8px;
  flex-direction: column;
`;

export default Wrapper;
